import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { legalDocuments, type LegalDocument } from '../data/legal';
export function Footer() {
  const [activeDoc, setActiveDoc] = useState<LegalDocument | null>(null);
  return <footer className="w-full bg-navy-deep" data-id="element-72" data-mp="32pfg0dp7nlz8">
      <div className="mx-auto w-full max-w-3xl px-5 pb-24 pt-10 text-center sm:px-6 sm:pb-12 sm:pt-12 md:pb-12" data-id="element-73" data-mp="36p6d0z5byyc7">
        <p className="font-display text-base font-bold text-white sm:text-lg" data-id="element-74" data-mp="3ueigrjhw2e74">
          Crédito Limpio en 30 Días
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[0.8rem] leading-relaxed text-white/50 sm:mt-4 sm:text-sm" data-id="element-75" data-mp="37fv17ktl04a">
          Este material es educativo y se basa en los derechos que la ley FCRA otorga a los
          consumidores en Estados Unidos. No somos una agencia de reparación de crédito ni ofrecemos
          asesoría legal. Los resultados varían según el historial de cada persona.
        </p>

        <nav aria-label="Enlaces legales" className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:mt-6" data-id="element-76" data-mp="2ez1joazlf0yu">
          {legalDocuments.map((doc, index) => <React.Fragment key={doc.id} data-id="element-77" data-mp="3gc0hdk3g7u7m" data-mpi={index}>
              {index > 0 && <span className="text-white/20" aria-hidden="true" data-id="element-78" data-mp="3v8rhxwouzbyt">
                  ·
                </span>}
              <button type="button" onClick={() => setActiveDoc(doc)} className="rounded text-[0.8rem] font-medium text-white/70 underline underline-offset-4 outline-none transition-colors duration-150 ease-smooth hover:text-gold focus-visible:ring-2 focus-visible:ring-gold sm:text-sm" data-id="element-79" data-mp="3q727ai5jt0b9">
                {doc.label}
              </button>
            </React.Fragment>)}
        </nav>

        <p className="mt-5 text-[0.7rem] text-white/35 sm:mt-6 sm:text-xs" data-id="element-80" data-mp="qt067zvk7a19">
          © {new Date().getFullYear()} Crédito Limpio en 30 Días. Todos los derechos reservados.
        </p>
      </div>

      <LegalModal document={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-81" data-mp="tvmqbhqesglw" />
    </footer>;
}